import axios from "axios";
import { getMUIComponent, InitializeMUIComponent } from './materialUIComponents';
import moment from 'moment';
import { createElement } from "react";

import { msalConfig } from '../authConfig';
import { PublicClientApplication } from '@azure/msal-browser';
import { InteractionRequiredAuthError, AuthError } from "@azure/msal-common";

export async function getAccessToken(){
    const msalInstance = new PublicClientApplication(msalConfig);
    const redirectResponse = await msalInstance.handleRedirectPromise();
    if (redirectResponse !== null) {
        // Acquire token silent success
        let accessToken = redirectResponse.accessToken;
        return accessToken;
    } else {
    // MSAL.js v2 exposes several account APIs, logic to determine which account to use is the responsibility of the developer
        const account = msalInstance.getAllAccounts()[0];
        let _scope = localStorage.getItem("application_scope");
        const accessTokenRequest = {
            scopes: [_scope],
            account: account,
        };

        try{
            if (localStorage.getItem("account_expiresOn") !== null && ((new Date(localStorage.getItem("account_expiresOn"))) > new Date())){
                return localStorage.getItem("account_accessToken");
            }else{

                let accessTokenResponse = await msalInstance
                    .acquireTokenSilent(accessTokenRequest);
                //Guardar esto en la sessionStorage xa que quede más prolijo. Se deja acá x compatibilidad con el homepage viejo
                localStorage.setItem("account_name", account.name);
                localStorage.setItem("account_username", account.username);
                localStorage.setItem("account_accessToken", accessTokenResponse.accessToken);
                localStorage.setItem("account_expiresOn", accessTokenResponse.expiresOn.toISOString());

                coreSetToken(window, "azureAccount.accountInfo.account.userName", account.username);
                coreSetToken(window, "azureAccount.accountInfo.account.name", account.name);
                return accessTokenResponse.accessToken;
            }

        } catch(error){
            //Acquire token silent failure, and send an interactive request
            console.log(error);
            if (error instanceof InteractionRequiredAuthError) {
                try{
                    let accessTokenResponse = await msalInstance.acquireTokenRedirect(accessTokenRequest);
                    return accessTokenResponse.accessToken;
                }catch(error){
                    // Acquire token interactive failure
                    console.log(error);   
                }
            }
        }
    }
}

export function map(){
    let _component = arguments[0];
    let _input = arguments[1];
    let _output = arguments[2];

    _output = translateRelativePaths(_output, _component, _input);
}

export async function mapObject(){
    let _component = arguments[0];
    let _source = arguments[1];
    let _output = arguments[2];
    let _orderBy = arguments.length > 3 ? arguments[3] : null;
    let _result = [];

    if (typeof _source === "object"){
        let keys = [];
        if (_orderBy !== null && _orderBy !== undefined){
            for(var key in _source){
                keys.push({
                    "id": key,
                    "order": coreSelectToken(_source[key], _orderBy)
                });
            }
            keys.sort((a, b) => a.order - b.order);
        }else{
            for(var key in _source){
                keys.push({
                    "id": key
                });
            }
        }

        for(var ind in keys){
            let key = keys[ind].id;
            let _itemOutput = clone(_output);
            let _item = {"key": key, "value": _source[key]};
            _result.push(await parseSchema(_component, _itemOutput, _item));
            // if (typeof _output == "object" && (_output.type == "uiComponent" || _output.type == "uiSchema")){
            //     _result.push(_component.renderUiSchema(_itemOutput, _component, _item));
            // }else{
            //     _result.push(translateRelativePaths(_itemOutput, _component, _item));
            // }
        }
    }
    return _result;
}

export async function concat(){
    let _component = arguments[0];
    let _props = arguments[1];
    let _input = arguments[2];
    
    let _result = "";
    for(var i =0; i < _props.length; i++){
        //_result+= translateRelativePaths(_props[i], _component, _input);
        _result+= await parseSchema(_component, _props[i], _input);
    }
    return _result;
}

export async function setUrl(){
    let _component = arguments[0];
    let _requestSchema = arguments[1];
    let _input = arguments[2] ?? null;

    let _url = "";
    if (_component == null){
        _url = _requestSchema.url;
    }else{
        _url = await parseSchema(_component, _requestSchema.url, _input);
        //Me fijo los urlRouteParams y los urlQueryParams
        if (_requestSchema.urlRouteParams !== undefined && _requestSchema.urlRouteParams !== null) {
            var urlRouteParams = await parseSchema(_component, _requestSchema.urlRouteParams, _input);
            if (_url.substring(_url.length - 1) === '/') {
                _url = _url.substring(0, _url.length - 1);
            }
            //urlRouteParams puede venir tanto en formato array para tener la opción del required...(formato similar al conditions)
            //o directo como clave valor

            if (Array.isArray(urlRouteParams)) {
                for (var i = 0; i < urlRouteParams.length; i++) {
                    if (urlRouteParams[i].required === true && (urlRouteParams[i].value === null || urlRouteParams[i].value === undefined || urlRouteParams[i].value === "" || (urlRouteParams[i].value === "0" && urlRouteParams[i].type === "number"))) {
                        console.log("Falta el valor xa la url " + _url + " del componente " + _component.coreDefinition.jsonSchema.options.id + " item " + urlRouteParams[i].id);
                        return "";
                    }
                    //me puedo fijar si el valor parsea a una fecha...entonces le cambio el formato xa q viaje x url..
                    _url += '/' + urlRouteParams[i].value;
                }
            } else {
                for (var item of Object.keys(urlRouteParams)) {
                    if (urlRouteParams[item].required === true && (urlRouteParams[item].value === null || urlRouteParams[item].value === undefined || urlRouteParams[item].value === "" || (urlRouteParams[item].value === "0" && urlRouteParams[item].type === "number"))) {
                        console.log("Falta el valor xa la url " + _url + " del componente " + _component.coreDefinition.jsonSchema.options.id + " item " + item);
                        return "";
                    }
                    //me puedo fijar si el valor parsea a una fecha...entonces le cambio el formato xa q viaje x url..
                    _url += '/' + urlRouteParams[item].value;
                }

            }

        }
    }

    if (_url && _url.substring(0,4) !== "http"){
        _url = window.backendBaseUrl + _url;
    }

    return _url;
}

export async function httpRequest (){
    let _component = arguments[0];
    let _requestSchema = arguments[1];
    let _callback = arguments.length > 2 ? arguments[2] : null;
    let _afterDefaultSuccess = arguments.length > 3 ? arguments[3] : null;

    let _input = _component == null ? null : _component.props.jsonSchema;
    let _url = await setUrl(_component, _requestSchema, _input);

    let _params = {};

    //Parseo el body x las dudas.
    let bodyData = _requestSchema.bodyData ?? {};
    if (!coreJsonIsEmpty(bodyData)){
        bodyData = await parseSchema(_component, bodyData, null);
    }      

    if (_url === ""){
        throw {
            name: "url",
            message: "No se pudo armar la url"
        };
        return;
    }

    let _type = _requestSchema["type"] ?? "GET";

    
    // Authentication Parameters
    const authenticationParameters = {
        scopes: [
            window.backendParameters[window.domain].Backend[window.application].Scope
        ]
    }
    //const _token = await authProvider.getAccessToken(authenticationParameters);
    if (window.anonymous !== "true"){
        const _token = await getAccessToken();
        _params.headers = {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json, application/octet-stream, application/pdf',
            'Authorization': 'Bearer ' + _token
        };
    }else{
        _params.headers = {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json, application/octet-stream, application/pdf'
        };
    }

    _params.responseType = 'arraybuffer';

    if (_requestSchema.axiosParams){
        _params = coreJsonMerge(_params, _requestSchema.axiosParams);
    }

    if (_requestSchema.headers){
        _params.headers = coreJsonMerge(_params.headers, _requestSchema.headers);
    }

    let _success = function(result){
        ////
        var blob;
        const contentType = result.headers['content-type'];
        let isFile = false;
        if (result.headers["content-disposition"] !== undefined && result.headers["content-disposition"].indexOf("filename=") !== -1){
            isFile = true;
        }
        if (!isFile && contentType && contentType.includes('application/json')) {
            // Convertir ArrayBuffer a JSON
            const jsonText = new TextDecoder().decode(new Uint8Array(result.data));
            if (jsonText !== ""){
                const jsonData = JSON.parse(jsonText);
                result.data = jsonData;
            }else{
                result.data = jsonText;
            }
        }else{
            if (!isFile && contentType && contentType.includes('text/plain')) {
                result.data = new TextDecoder().decode(new Uint8Array(result.data));
            }else{
                blob = new Blob([result.data], { type: contentType });
            }
        }
        ////
        let _arguments = [];
        _arguments[0] = _component;
        _arguments[1] = result;
        if (_requestSchema.success){
            if (typeof _requestSchema["success"] === "function"){
                _requestSchema.success.apply(null, _arguments);
            }else{
                executeSchema(_component, _requestSchema.success, result);
            }
        }else{            
            if (isFile || (contentType && (!contentType.includes('application/json') && !contentType.includes('text/plain')))){
                let filename = _component.coreDefinition.jsonSchema.options.id;
                if (result.headers["content-disposition"] !== undefined && result.headers["content-disposition"].indexOf("filename=") !== -1){
                    filename = result.headers["content-disposition"].split(';').filter((x) => {if (x.indexOf('filename=') !== -1){return x;}})[0].split('=')[1]
                }
    
                // Crea un enlace y asigna el Blob como URL del enlace
                var downloadLink = document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(blob);
                downloadLink.download = filename;
                downloadLink.innerHTML = 'Descargar archivo';
                
                // Agrega el enlace al DOM
                document.body.appendChild(downloadLink);
                
                // Simula un clic en el enlace para iniciar la descarga automáticamente
                downloadLink.click();
                
                // Elimina el enlace del DOM después de la descarga
                document.body.removeChild(downloadLink);

            }

            if (isFunction(_callback)){
                _callback(result);
            }else{
                if (_component.hasAction("defaultProcessSuccess")){
                    _component.defaultProcessSuccess(result);
                }else{            
                    //Me fijo si tengo información xa mostrar.
                    if (coreTokenExists(result, "data.validations") && result.data.validations.length > 0){
                        let _typeOfMessage = result.data.validations[0].status ? "info" : "error";
                        let _message = "";
                        for(let _validation of result.data.validations){
                            _message+= (_message !== "" ? "\n" : "") + _validation.message;
                        }

                        if (_message !== ""){
                            if (_component.hasAction("showSnackbar")){
                                _component.executeAction("showSnackbar", _message, _typeOfMessage);
                            }else{
                                console.log(_message);
                            }
                        }
                    }
                    if (isFunction(_afterDefaultSuccess)){
                        _afterDefaultSuccess(result);
                    }
                }
            }
        }
    }

    let _error = async function (result){
        let response = result.response;
        let _arguments = [];
        _arguments[0] = _component;
        _arguments[1] = result;
        let _typeOfMessage = "error";

        if (response === undefined){
            let _message = "Error: " + (result.code !== undefined) ? result.code : " al realizar la petición";
            if (_component.hasAction("defaultProcessError")){
                _component.defaultProcessError(result);
            }else{
                if (_component.hasAction("showSnackbar")){
                    _component.executeAction("showSnackbar", _message, _typeOfMessage);
                }else{
                    _component.notifyParent("error", null, _message);
                }
            }
            console.log("Error con: " + JSON.stringify(_message));
            return;
        }

        if (response.status === 404){
            if (_component.hasAction("defaultProcessError")){
                _component.defaultProcessError(result);
            }else{
                let _message = "No se encuentra endpoint: " + result.config.url;
                if (_component.hasAction("showSnackbar")){
                    _component.executeAction("showSnackbar", _message, _typeOfMessage);
                }else{
                    _component.notifyParent("error", null, _message);
                }
                console.log("Error con: " + JSON.stringify(_message));
            }
            return;
        }

        // Verificar el tipo de contenido utilizando los headers de la respuesta
        const contentType = response.headers.get('content-type');
        var file;
        let isFile = false;
        if (result.headers != undefined && result.headers["content-disposition"] !== undefined && result.headers["content-disposition"].indexOf("filename=") !== -1){
            isFile = true;
        }

        if (!isFile && contentType.includes('application/json')) {
            // Verificar si el error es un blob
            if (result.response && result.response.data instanceof Blob && result.response.data.type && result.response.data.type.toLowerCase().indexOf('json') !== -1) {
                // Convertir el blob a texto
                const reader = new FileReader();
                const content = await new Promise((resolve, reject) => {
                    reader.onerror = () => {
                      reader.abort();
                      reject(new DOMException("Error al leer el blob."));
                    };
                    reader.onload = () => {
                      resolve(reader.result);
                    };
                    reader.readAsText(result.response.data);
                  });
                  // Parsear el contenido como JSON
                  const jsonResponse = JSON.parse(content);
                  result.response.data = jsonResponse;
            }else{
                if (result.response && result.response.data instanceof ArrayBuffer) {
                    // Convertir ArrayBuffer a JSON
                    const jsonText = new TextDecoder().decode(new Uint8Array(result.response.data));
                    const jsonData = JSON.parse(jsonText);
                    result.response.data = jsonData;
                    console.log('JSON Data:', jsonData);
                }
            }

            // Convertir ArrayBuffer a JSON
            // const jsonText = new TextDecoder().decode(new Uint8Array(response.data));
            // const jsonData = JSON.parse(jsonText);
            // result.response.data = jsonData;
            // console.log('JSON Data:', jsonData);
        }else{
            if (!isFile && contentType && contentType.includes('text/plain')) {
                response.data = new TextDecoder().decode(new Uint8Array(response.data));
            }else{
                console.log('Blob recibido:', file);
                file = new Blob([response.data], { type: contentType });
            }
        }
        
        if (typeof _requestSchema["error"] === "function"){
            //_arguments[1] = result;
            _requestSchema.error.apply(null, _arguments);
        }else{
            console.log('Show error notification! ' + JSON.stringify(result));
            if (_component.hasAction("defaultProcessError")){
                _component.defaultProcessError(result);
            }else{
                let _message = "";
                if (coreTokenExists(result, "response.data.Message")){
                    _message+= "\n" + result.response.data.Message;
                }else{
                    //Me fijo si tengo información xa mostrar.
                    if (coreTokenExists(result, "response.data.validations") && result.response.data.validations.length > 0){
                        _typeOfMessage = result.response.data.validations[0].status ? "info" : "error";
                        for(let _validation of result.response.data.validations){
                            _message+= (_message !== "" ? "\n" : "") + _validation.message;
                        }
                    }else{
                        if (coreTokenExists(result, "response.data")){
                            _message+= "\n" + JSON.stringify(result.response.data);
                        }else{
                            _message = "Hubo errores en la operación, y no pudo ser completada!!!";
                        }
                    }
                }
                
                if (_component.hasAction("showSnackbar")){
                    _component.executeAction("showSnackbar", _message, _typeOfMessage);
                }else{
                    _component.notifyParent("error", null, _message);
                }
                console.log("Error con: " + JSON.stringify(_message));
            }
        }
    }
 
    switch (_type) {
        case "GET": 
            axios
            .get(_url, _params)
            .then((response) => {
                _success(response)
            })
            .catch((error) => {
                _error(error)
            });
            // .error((response) => {console.log('error en el request '+ _url + ' error: ' + response)});   
            break;
        case "POST":
            axios
            .post(_url, bodyData, _params)
            .then((response) => {
                _success(response)
            }).catch((error) => {
                _error(error)
            });
            // .error((response) => {console.log('error en el request '+ _url + ' error: ' + response)});   
            break;
        case "PUT":
            axios
            .put(_url, bodyData, _params)
            .then((response) => {
                _success(response)
            }).catch((error) => {
                _error(error)
            });
            // .error((response) => {console.log('error en el request '+ _url + ' error: ' + response)});   
            break;
        case "DELETE":
            _params.data = bodyData;
            axios
            .delete(_url, _params)
            .then((response) => {
                _success(response)
            }).catch((error) => {
                _error(error)
            });
            // .error((response) => {console.log('error en el request '+ _url + ' error: ' + response)});   
            break; 
        case "PATCH":
            axios
            .patch(_url, bodyData, _params)
            .then((response) => {
                _success(response)
            }).catch((error) => {
                _error(error)
            });
            // .error((response) => {console.log('error en el request '+ _url + ' error: ' + response)});   
            break;
        
    }
}

// export async function httpRequest (){
//     let _component = arguments[0];
//     let _requestSchema = arguments[1];
//     let _callback = arguments.length > 2 ? arguments[2] : null;
//     let _afterDefaultSuccess = arguments.length > 3 ? arguments[3] : null;

//     let _input = _component == null ? null : _component.props.jsonSchema;
//     let _url = await setUrl(_component, _requestSchema, _input);

//     let _params = {};

//     //Parseo el body x las dudas.
//     let bodyData = _requestSchema.bodyData ?? {};
//     if (!coreJsonIsEmpty(bodyData)){
//         bodyData = await parseSchema(_component, bodyData, null);
//     }      

//     if (_url === ""){
//         throw {
//             name: "url",
//             message: "No se pudo armar la url"
//         };
//         return;
//     }

//     let _type = _requestSchema["type"] ?? "GET";

    
//     // Authentication Parameters
//     const authenticationParameters = {
//         scopes: [
//             window.backendParameters[window.domain].Backend[window.application].Scope
//         ]
//     }
//     //const _token = await authProvider.getAccessToken(authenticationParameters);
//     const _token = await getAccessToken();
//     _params.headers = {
//         'Access-Control-Allow-Origin': '*',
//         'Content-Type': 'application/json, application/octet-stream, application/pdf',
//         'Authorization': 'Bearer ' + _token
//     };

//     if (_requestSchema.headers){
//         _params.headers = coreJsonMerge(_params.headers, _requestSchema.headers);
//     }

//     let _success;
//     if ((coreTokenExists(_requestSchema, "axiosParams.responseType") && (_requestSchema.axiosParams.responseType === 'blob' || _requestSchema.axiosParams.responseType === 'arraybuffer'))){
//         // delete headers["Content-Type"];
//         // delete headers["content-type"];
//         // delete headers.accepts;
//         // delete headers.accept;
//         // delete headers.dataType;

//         //_params = {..._params, ..._requestSchema.axiosParams};

//         _params.responseType = 'arraybuffer';

//         _success = function (response) {
//             // create file link in browser's memory
//             let filename = _component.coreDefinition.jsonSchema.options.id;
//             if (response.headers["content-disposition"] && response.headers["content-disposition"].indexOf("filename=") !== -1){
//                 filename = response.headers["content-disposition"].split(';').filter((x) => {if (x.indexOf('filename=') !== -1){return x;}})[0].split('=')[1]
//             }
//             const type = response.headers['content-type'];
//             //20240110 - Comento esto y dejo la descarga con el createElement
//             //var fileDownload = require('js-file-download');
//             //fileDownload(response.data, filename, type);

//             ////
// var blob;
// const contentType = response.headers['content-type'];

//   if (contentType && contentType.includes('application/json')) {
//     // Convertir ArrayBuffer a JSON
//     const jsonText = new TextDecoder().decode(new Uint8Array(response.data));
//     const jsonData = JSON.parse(jsonText);
//     console.log('JSON Data:', jsonData);
//   } else if (contentType && (contentType.includes('application/octet-stream') || contentType.includes('application/pdf'))) {
//     // Manejar como Blob
//     // blob = new Blob([response.data], { type: 'application/octet-stream' });
//     console.log('Blob recibido:', blob);
//     // Puedes seguir procesando el Blob según necesites

//     // if (response.config.headers.responseType.toLowerCase() === "arraybuffer"){
//     //     var byteArray = new Uint8Array(response.data);
//     //     blob = new Blob([byteArray], { type: contentType });
//     // }else{
//         blob = new Blob([response.data], { type: contentType });
//     // }

//   }else{
//     console.log("no tengo acción para parsear el contenido de tipo: " + contentType);
//   }
//   ////

            
//             // Crea un enlace y asigna el Blob como URL del enlace
//             var downloadLink = document.createElement('a');
//             downloadLink.href = window.URL.createObjectURL(blob);
//             downloadLink.download = filename;
//             downloadLink.innerHTML = 'Descargar archivo';
            
//             // Agrega el enlace al DOM
//             document.body.appendChild(downloadLink);
            
//             // Simula un clic en el enlace para iniciar la descarga automáticamente
//             downloadLink.click();
            
//             // Elimina el enlace del DOM después de la descarga
//             document.body.removeChild(downloadLink);

//             if (isFunction(_callback)){
//                 _callback(response);
//             }else{
//                 if (_component.hasAction("defaultProcessSuccess")){
//                     _component.defaultProcessSuccess(response);
//                 }else{
//                     if (isFunction(_afterDefaultSuccess)){
//                         _afterDefaultSuccess(response);
//                     }
//                 }
//             }
//         }
//     }else{

//         _params.responseType = 'arraybuffer';

//         _success = function(result){
// ////
// var blob;
// const contentType = result.headers['content-type'];

// if (contentType && contentType.includes('application/json')) {
//     // Convertir ArrayBuffer a JSON
//     const jsonText = new TextDecoder().decode(new Uint8Array(result.data));
//     const jsonData = JSON.parse(jsonText);
//     result.data = jsonData;
//     console.log('JSON Data:', jsonData);
// } else if (contentType && contentType.includes('application/octet-stream')) {
//     console.log('Blob recibido:', blob);
//     blob = new Blob([result.data], { type: contentType });
// }
// ////
//             let _arguments = [];
//             _arguments[0] = _component;
//             _arguments[1] = result;
//             if (_requestSchema.success){
//                 if (typeof _requestSchema["success"] === "function"){
//                     _requestSchema.success.apply(null, _arguments);
//                 }else{
//                     executeSchema(_component, _requestSchema.success, result);
//                 }
//             }else{            
//                 if (contentType !== "application/json"){
//                     let filename = _component.coreDefinition.jsonSchema.options.id;
//                     if (result.headers["content-disposition"] && result.headers["content-disposition"].indexOf("filename=") !== -1){
//                         filename = result.headers["content-disposition"].split(';').filter((x) => {if (x.indexOf('filename=') !== -1){return x;}})[0].split('=')[1]
//                     }
        
//                     // Crea un enlace y asigna el Blob como URL del enlace
//                     var downloadLink = document.createElement('a');
//                     downloadLink.href = window.URL.createObjectURL(blob);
//                     downloadLink.download = filename;
//                     downloadLink.innerHTML = 'Descargar archivo';
                    
//                     // Agrega el enlace al DOM
//                     document.body.appendChild(downloadLink);
                    
//                     // Simula un clic en el enlace para iniciar la descarga automáticamente
//                     downloadLink.click();
                    
//                     // Elimina el enlace del DOM después de la descarga
//                     document.body.removeChild(downloadLink);

//                 }

//                 if (isFunction(_callback)){
//                     _callback(result);
//                 }else{
//                     if (_component.hasAction("defaultProcessSuccess")){
//                         _component.defaultProcessSuccess(result);
//                     }else{            
//                         //Me fijo si tengo información xa mostrar.
//                         if (coreTokenExists(result, "data.validations") && result.data.validations.length > 0){
//                             let _typeOfMessage = result.data.validations[0].status ? "info" : "error";
//                             let _message = "";
//                             for(let _validation of result.data.validations){
//                                 _message+= (_message !== "" ? "\n" : "") + _validation.message;
//                             }

//                             if (_message !== ""){
//                                 if (_component.hasAction("showSnackbar")){
//                                     _component.executeAction("showSnackbar", _message, _typeOfMessage);
//                                 }else{
//                                     console.log(_message);
//                                 }
//                             }
//                         }
//                         if (isFunction(_afterDefaultSuccess)){
//                             _afterDefaultSuccess(result);
//                         }
//                     }
//                 }
//             }
            
//         }
//     }

//     let _error = async function (result){
//         let response = result.response;
//         let _arguments = [];
//         _arguments[0] = _component;
//         _arguments[1] = result;
//         let _typeOfMessage = "error";

//         // Verificar el tipo de contenido utilizando los headers de la respuesta
//         const contentType = response.headers.get('content-type');
//         var file;        
//         if (contentType.includes('application/json')) {
//             // Convertir ArrayBuffer a JSON
//             const jsonText = new TextDecoder().decode(new Uint8Array(response.data));
//             const jsonData = JSON.parse(jsonText);
//             result.response.data = jsonData;
//             console.log('JSON Data:', jsonData);
//         } else if (contentType.includes('application/octet-stream') || contentType.includes('application/pdf')) {
//             // Si la respuesta es un Blob
//             const type = response.headers['content-type'];
//             // if (response.config.headers.responseType === "arraybuffer"){
//             //     var byteArray = new Uint8Array(response.data);
//             //     file = new Blob([byteArray], { type: type });
//             // }else{
//                 file = new Blob([response.data], { type: type });
//             // }
//             if (file.size > 0){
//                 await file.text()
//                     .then(value => {
//                         try{
//                             result.response.data = JSON.parse(value);                            
//                         }catch(ex){
//                             result.response.data = value;
//                         }
//                     })
//                     .catch(error => {
//                         console.log("Something went wrong" + error);
//                     });
//             }else{
//                 console.log("No file returned.")
//             }
//         }
//         if (typeof _requestSchema["error"] === "function"){
//             _requestSchema.error.apply(null, _arguments);
//         }else{
//             console.log('Show error notification! ' + JSON.stringify(result));
//             if (_component.hasAction("defaultProcessError")){
//                 if (result.response.data.type === "application/json"){
//                 }
//                 _component.defaultProcessError(result);
//             }else{
//                 let _message = "";
//                 if (coreTokenExists(result, "response.data.Message")){
//                     _message+= "\n" + result.response.data.Message;
//                 }else{
//                     //Me fijo si tengo información xa mostrar.
//                     if (coreTokenExists(result, "response.data.validations") && result.response.data.validations.length > 0){
//                         _typeOfMessage = result.response.data.validations[0].status ? "info" : "error";
//                         for(let _validation of result.response.data.validations){
//                             _message+= (_message !== "" ? "\n" : "") + _validation.message;
//                         }
//                     }else{
//                         if (coreTokenExists(result, "response.data")){
//                             _message+= "\n" + JSON.stringify(result.response.data);
//                         }else{
//                             _message = "Hubo errores en la operación, y no pudo ser completada!!!";
//                         }
//                     }
//                 }
                
//                 if (_component.hasAction("showSnackbar")){
//                     _component.executeAction("showSnackbar", _message, _typeOfMessage);
//                 }else{
//                     _component.notifyParent("error", null, _message);
//                 }
//                 console.log("Error con: " + JSON.stringify(_message));
//             }
//         }
//     }

//     // let _error = async function(result){
//     //     let _arguments = [];
//     //     _arguments[0] = _component;
//     //     _arguments[1] = result;
//     //     let _typeOfMessage = "error";

//     //     let file = new Blob([JSON.stringify(result.response.data)], {type: 'application/json'});
//     //     if (file.size > 0){
//     //         await file.text()
//     //             .then(value => {
//     //                 try{
//     //                     result.response.data = JSON.parse(value);                            
//     //                 }catch(ex){
//     //                     result.response.data = value;
//     //                 }
//     //             })
//     //             .catch(error => {
//     //                 console.log("Something went wrong" + error);
//     //             });
//     //     }else{
//     //         console.log("No file returned.")
//     //     }

//     //     if (typeof _requestSchema["error"] === "function"){
//     //         _requestSchema.error.apply(null, _arguments);
//     //     }else{
//     //         console.log('Show error notification! ' + JSON.stringify(result));
//     //         if (_component.hasAction("defaultProcessError")){
//     //             if (result.response.data.type === "application/json"){
//     //             }
//     //             _component.defaultProcessError(result);
//     //         }else{
//     //             let _message = "";
//     //             if (coreTokenExists(result, "response.data.Message")){
//     //                 _message+= "\n" + result.response.data.Message;
//     //             }else{
//     //                 //Me fijo si tengo información xa mostrar.
//     //                 if (coreTokenExists(result, "response.data.validations") && result.response.data.validations.length > 0){
//     //                     _typeOfMessage = result.response.data.validations[0].status ? "info" : "error";
//     //                     for(let _validation of result.response.data.validations){
//     //                         _message+= (_message !== "" ? "\n" : "") + _validation.message;
//     //                     }
//     //                 }else{
//     //                     if (coreTokenExists(result, "response.data")){
//     //                         _message+= "\n" + JSON.stringify(result.response.data);
//     //                     }else{
//     //                         _message = "Hubo errores en la operación, y no pudo ser completada!!!";
//     //                     }
//     //                 }
//     //             }
                
//     //             if (_component.hasAction("showSnackbar")){
//     //                 _component.executeAction("showSnackbar", _message, _typeOfMessage);
//     //             }else{
//     //                 _component.notifyParent("error", null, _message);
//     //             }
//     //             console.log("Error con: " + JSON.stringify(_message));
//     //         }
//     //     }
//     // }
  
//     switch (_type) {
//         case "GET": 
//             axios
//             .get(_url, _params)
//             .then((response) => {
//                 _success(response)
//             })
//             .catch((error) => {
//                 _error(error)
//             });
//             // .error((response) => {console.log('error en el request '+ _url + ' error: ' + response)});   
//             break;
//         case "POST":
//             axios
//             .post(_url, bodyData, _params)
//             .then((response) => {
//                 _success(response)
//             }).catch((error) => {
//                 _error(error)
//             });
//             // .error((response) => {console.log('error en el request '+ _url + ' error: ' + response)});   
//             break;
//         case "PUT":
//             axios
//             .put(_url, bodyData, _params)
//             .then((response) => {
//                 _success(response)
//             }).catch((error) => {
//                 _error(error)
//             });
//             // .error((response) => {console.log('error en el request '+ _url + ' error: ' + response)});   
//             break;
//         case "DELETE":
//             _params.data = bodyData;
//             axios
//             .delete(_url, _params)
//             .then((response) => {
//                 _success(response)
//             }).catch((error) => {
//                 _error(error)
//             });
//             // .error((response) => {console.log('error en el request '+ _url + ' error: ' + response)});   
//             break; 
//         case "PATCH":
//             axios
//             .patch(_url, bodyData, _params)
//             .then((response) => {
//                 _success(response)
//             }).catch((error) => {
//                 _error(error)
//             });
//             // .error((response) => {console.log('error en el request '+ _url + ' error: ' + response)});   
//             break;
        
//     }
// }

export async function httpRequestSync (){
    let _component = arguments[0];
    let _requestSchema = arguments[1];
    //let _callback = arguments.length > 2 ? arguments[2] : null;

    let _input = _component == null ? null : _component.props;
    let _url = await setUrl(_component, _requestSchema, _input);

    let _type = _requestSchema["type"] ?? "GET";

    let _error = function(result){
        let _arguments = [];
        _arguments[0] = _component;
        _arguments[1] = result;
        if (typeof _requestSchema["error"] === "function"){
            _requestSchema.error.apply(null, _arguments);
        }else{
            console.log('Show error notification! ' + JSON.stringify(result));
        }
    }

    // Authentication Parameters
    const authenticationParameters = {
        scopes: [
            window.backendParameters[window.domain].Backend[window.application].Scope
        ]
    }
  
    //const _token = await authProvider.getAccessToken(authenticationParameters);
    //const _token = await getAccessToken();

    const headers = {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json'
    };

    if (window.anonymous !== "true"){
        const _token = await getAccessToken();
        headers.Authorization = 'Bearer ' + _token;        
    }
    
    let bodyData = _requestSchema.bodyData ?? {};
      
    let response = null;
    switch (_type) {
        case "GET": 
            response = await axios.get(_url, {headers: headers})
                .catch((response) => {console.log('error en el request '+ _url + ' error: ' + response); return response.response});   
            break;
        case "POST":
            response = await axios.post(_url, bodyData, {headers: headers});
            break;
        case "PUT":
            response = await axios.put(_url, bodyData, {headers: headers});
            break;
        case "DELETE":
            response = await axios.delete(_url, bodyData, {headers: headers});   
            break; 
        case "PATCH":
            response = await axios.patch(_url, bodyData, {headers: headers})
            break;
        
    }
    return response;
}

export function isFunction(arg){
    return (typeof arg === "function");
}

export function setToken() {
    let _component = arguments[0];
    let _steps = arguments(1);
    let _input = arguments[2];

    if (Array.isArray(_steps)){
        for(var i = 0; i < _steps.length; i++){
            coreSetToken(_component, _steps[i].path, _steps[i].value);
        }
    }
}

export function clone(jObject){
    if (jObject === null){
        return null;
    }

    if (jObject === undefined){
        return undefined;
    }

    if (jObject.$$typeof !== undefined){
        return jObject;
    }

    if (jObject instanceof HTMLElement){
        return jObject;
    }

    if (Array.isArray(jObject)){
        let _result = [];
        for(var i = 0; i < jObject.length; i++){
            _result.push(clone(jObject[i]));
        }
        return _result;
    }else if (typeof jObject === "object"){
        let _result = {};
        for(var item in jObject){
            _result[item] = clone(jObject[item]);
        }
        return _result;
    }else if (typeof jObject === "function"){
        return jObject;
    }else{
        return jObject;
    }
}

//Generic functions
export function coreTokenExists(object, path) {
    try {
        if (!object ){
            return false;
        }
        if (path === null || path === undefined){
            return false;
        }

        var arrPath = path.split('.');
        var currentItem = object;
        for (var i = 0; i < arrPath.length; i++) {
            if (!currentItem || (!currentItem.hasOwnProperty(arrPath[i])  && currentItem[arrPath[i]] === undefined)) {
                return false;
            } else {
                currentItem = currentItem[arrPath[i]];
            }
        }
        return true;
    } catch (e) {
        console.error("Error en coreTokeExists " + e);
    }
}

export function coreSelectToken(object, path) {
    try {
        if (!object ){
            return null;
        }

        if (!path || path === ""){
            return object;
        }

        var arrPath = path.split('.');
        var currentItem = object;
        for (var i = 0; i < arrPath.length; i++) {
            if (!currentItem || !currentItem.hasOwnProperty(arrPath[i])) {
                if (arrPath[i].indexOf("[") !== -1){
                    let _index = arrPath[i].substr(arrPath[i].indexOf('[')+1, (arrPath[i].indexOf(']') - arrPath[i].indexOf('[')-1));
                    let _path = arrPath[i].substr(0, arrPath[i].indexOf("["));
                    if (currentItem[_path] && _index < currentItem[_path].length){
                        currentItem = currentItem[_path][_index];
                    }else{
                        return null;
                    }
                }else{
                    return null;
                }
            } else {
                currentItem = currentItem[arrPath[i]];
            }
        }
        return currentItem;
    } catch (e) {
        console.error("Error en coreTokeExists " + e);
    }
}

export function coreSetToken(object, path, value) {
    var arrPath = path.split('.');
    var currentItem = object;
    var i = 0;
    try {
        for (i = 0; i < arrPath.length - 1; i++) {
            if (!currentItem.hasOwnProperty(arrPath[i]) || currentItem[arrPath[i]] === null || currentItem[arrPath[i]] === undefined) {
                currentItem[arrPath[i]] = JSON.parse('{}');
            }
            currentItem = currentItem[arrPath[i]];

        }
        currentItem[arrPath[arrPath.length-1]] = value;
    } catch (e) {
        console.error("Error en coreSetToken: " + e);
        console.log('i: ' + i + ' arrPath[i]: ' + arrPath[i]);
    }
};

export function translatePropsToUiComponents(jsonData, rootComponent, input){    
    if (jsonData){
        var _keys = Object.keys(jsonData);
        for(var _ind in _keys){
            if (jsonData[_keys[_ind]] == null || jsonData[_keys[_ind]] === undefined){
                console.log('estoy acá');
            }else{
                if (jsonData[_keys[_ind]].hasOwnProperty("type") && jsonData[_keys[_ind]].type === "uiComponent"){
                    let _props = jsonData[_keys[_ind]].props ?? {};
                    // if (rootComponent.props.jsonSchema.options.renderer === "antd"){
                    //     jsonData[_keys[_ind]] = getAntDComponent(rootComponent, input, jsonData[_keys[_ind]], jsonData[_keys[_ind]].children, _props);
                    // }else{
                        jsonData[_keys[_ind]] = rootComponent.renderUiSchema(jsonData[_keys[_ind]], rootComponent.props.jsonSchema, input);
                        // jsonData[_keys[_ind]] = getMUIComponent(component);                        
                    // }
                    //jsonData[_keys[_ind]] = getDynamicComponent(rootComponent, component, jsonData[_keys[_ind]], jsonData[_keys[_ind]].children, _props);
                }    
            }
        }    
    }
    return jsonData;
}

// export function selectToken(jsonObject, path){        
//     if (path === null){
//         return jsonObject;
//     }
    
//     if ((typeof jsonObject != "object") && (typeof jsonObject !== "array")){
//         return null;
//     }

//     let _arrPath = path.split('.');

//     if ((typeof jsonObject == "object")){
//         let token = _arrPath.shift();
//         if (_arrPath.length == 0){
//             try{
//                 return jsonObject[token];
//             }catch(ex){
//                 console.log(ex);
//             }
//         }else{
//             return selectToken(jsonObject[token], _arrPath.join('.'));
//         }
//     }else{
//         // if ((typeof jsonObject == "array")){
//             let arrToken = _arrPath.shift();
//             let index = arrToken.substring(arrToken.indexOf('['), arrToken.indexOf(']'));
//             let token = arrToken.substring(0, arrToken.indexOf('['));
            
//             return selectToken(jsonObject[token][index], _arrPath.join('.'));
//         // }
//     }
// }

export function coreJsonIsEmpty(json){
    return ((!json) || (Object.keys(json).length === 0));
}

export function coreJsonMerge(_json1, _json2){

    if (_json1 !== undefined && _json1 !== null && _json1.$$typeof){
        //Si es un componente react.. no hago merge
        return _json1;
    }

    let json1 = clone(_json1);
    let json2 = clone(_json2);

    if (json1 === null){
        return json2;
    }

    if (json1 === undefined){
        return json2;
    }
    if (json2 === null){
        return json2;
    }
    if (typeof json1 !== 'object'){
        return json2;
    }

    if (typeof json2 != 'object'){
        return json2;
    }
    
    if (Array.isArray(json2)){
        if (Array.isArray(json1)){            
            json2.forEach((element, ind) => {
                if (ind > json1.length -1){
                    json1.push(element);
                }else{
                    json1[ind] = coreJsonMerge(json1[ind], json2[ind]);
                }
            });
        }else{
            return json2;
        }
    }else{
        for(var _prop in json2){
            try{
                json1[_prop] = coreJsonMerge(json1[_prop], json2[_prop]);
            }catch(ex){
                console.log(ex);
            }

        }
    }
    return json1;
}

export function parseFunction(jsonObject, _self) {
    if (!jsonObject){
        return jsonObject;
    }

    if (typeof jsonObject === "string" && jsonObject.startsWith("/Function(") && jsonObject.endsWith(")/")) {
        jsonObject = jsonObject.substring(10, jsonObject.length - 2).replaceAll("this.", "_self.");
        try{
            return eval("(" + jsonObject + ")");
        }catch(ex){
            throw new Error("No puedo parsear la función: " + jsonObject + "ex: " + ex);
        }
    }
    return jsonObject;
}

export async function translateFunction(jsonData, rootComponent){
    let _functions = ["executeAction", "httpRequest", "setData", "setDataSource", "map", "concat"];
    if (jsonData){
        if (typeof jsonData == "object"){
            
            if (jsonData.hasOwnProperty("type") && _functions.indexOf(jsonData.type) !== -1){
                let _parseSchema = JSON.parse(JSON.stringify(jsonData));
                jsonData = function(event) {
                    executeSchema.apply(null, [rootComponent, _parseSchema, event]);
                }
            }
        }else{
            if (typeof jsonData === "string" &&
            jsonData.startsWith("/Function(") &&
            jsonData.endsWith(")/")) {
                let value = jsonData.substring(10, jsonData.length - 2).replace("this.", "rootComponent.");
                try{
                    jsonData = eval("(" + value + ")");
                }catch(ex){                    
                    throw new Error("No puedo hacer translate de la function: " + value);
                }
            }
        }
    }
    return jsonData;
}

export async function translateFunctions(jsonData, rootComponent){
    let _functions = ["executeAction", "httpRequest", "setData", "setDataSource", "map", "concat"];
    if (jsonData){
        if (jsonData.$$typeof !== undefined){
            return jsonData;
        }
        var _keys = Object.keys(jsonData);
        for(var _ind in _keys){
            if (jsonData[_keys[_ind]]){
                if (typeof jsonData[_keys[_ind]] == "array"){
                    for(var i = 0; i < jsonData[_keys[_ind]].length; i++){
                        jsonData[_keys[_ind]][i] = await translateFunctions(jsonData[_keys[_ind]][i], rootComponent);
                    }
                }else{
                    if (typeof jsonData[_keys[_ind]] == "object"){
                        
                        if (jsonData[_keys[_ind]].hasOwnProperty("type") && _functions.indexOf(jsonData[_keys[_ind]].type) !== -1){
                            let _parseSchema = JSON.parse(JSON.stringify(jsonData[_keys[_ind]]));
                            jsonData[_keys[_ind]] = function(event) {
                                executeSchema.apply(null, [rootComponent, _parseSchema, event]);
                            }
                        }
                    }else{
                        if (typeof jsonData[_keys[_ind]] === "string" &&
                        jsonData[_keys[_ind]].startsWith("/Function(") &&
                        jsonData[_keys[_ind]].endsWith(")/")) {
                            let value = jsonData[_keys[_ind]].substring(10, jsonData[_keys[_ind]].length - 2).replace("this.", "rootComponent.");
                            jsonData[_keys[_ind]] = eval("(" + value + ")");
                        }
                    }
                }

            }
        }    
    }
    return jsonData;
}

export function translateRelativePaths(jsonData, component, input){
    if (jsonData === null || jsonData === undefined){
        return jsonData;
    }
    let _type = typeof jsonData;
    if (_type == "string"){
        if (jsonData.substring(0,1) == "#" && jsonData.length > 1 && (jsonData.substring(1,2) == "/" || jsonData.substring(1,2) == "_")){    
            if (jsonData.substring(1,2) == "_"){
                //Relative to component
                if (jsonData.length == 2){ //si es "#_" entonces hace referencia a todo el parámetro
                    jsonData = clone(input);
                }else{
                    jsonData = coreSelectToken(input, jsonData.substring(2));
                }
            }else{
                //Relative to rootComponent
                if (jsonData.substring(2).startsWith("this.")){
                    jsonData = coreSelectToken(component, jsonData.substring(7));
                }else if (jsonData.substring(2).startsWith("options.")){
                    jsonData = coreSelectToken(component.coreDefinition.jsonSchema, jsonData.substring(2));
                }else{
                    jsonData = coreSelectToken(component.coreDefinition.jsonSchema, jsonData.substring(2));
                }
                //jsonData = coreSelectToken(component.props.jsonSchema, jsonData.substring(2));
            }
        }else{
            if (jsonData.substring(0,1) == "$"){
                let _value = (new Date()).toJSON().substring(0,10);
                switch (jsonData){
                    case "$TODAY": 
                        _value  = new moment();
                        _value = _value.add(_value.utcOffset(), 'minutes').toJSON().substring(0,10);
                        jsonData = _value;
                        break;
                        case "$NOW": 
                        jsonData = (new Date()).toISOString();
                        break;
                    case "$BOM":
                        _value  = new moment().startOf('month');
                        _value = _value.add(_value.utcOffset(), 'minutes').toJSON().substring(0,10);
                        jsonData = _value;
                        break;
                    case "$EOM":
                        _value  = new moment().endOf('month');
                        _value = _value.add(_value.utcOffset(), 'minutes').toJSON().substring(0,10);
                        jsonData = _value;
                        break;
                    case "$BOMB":
                        //Begin of month before
                        _value  = new moment().startOf('month');
                        _value = _value.add(_value.utcOffset(), 'minutes').subtract(1, 'month').toJSON().substring(0,10);
                        jsonData = _value;
                        break;
                    case "$EOMB":
                        _value  = new moment().startOf('month');
                        _value = _value.add(_value.utcOffset(), 'minutes').subtract(1, 'day').toJSON().substring(0,10);
                        jsonData = _value;
                        break;
                    case "$USERID": 
                        jsonData = localStorage.getItem("account_username");
                        break;
                    case "$NULL": 
                        jsonData = null;
                        break;
                    default:
                        if (jsonData.split('_')[0] === "$TODAY"){
                            _value  = moment(_value).add(jsonData.split('_')[1]*1, jsonData.split('_')[2]);
                            jsonData = (new Date(_value)).toJSON().substring(0,10);
                        }
                        break;
                }
            }
        }
    }else{
        if (jsonData.$$typeof !== undefined){
            return jsonData;
        }
        var _keys = Object.keys(jsonData);
        for(var _ind in _keys){
            if (typeof jsonData[_keys[_ind]] == "array"){
                for(var i = 0; i < jsonData[_keys[_ind]].length; i++){
                    jsonData[_keys[_ind]][i] = translateRelativePaths(jsonData[_keys[_ind]][i], component, input);
                }
            }else{
                jsonData[_keys[_ind]] = translateRelativePaths(jsonData[_keys[_ind]], component, input);
            }
        }    
    }
    return jsonData;
}

export function castToType(type, value, inputFormat){
    let _value;
    if (value === ""){
        return value;
    }

    if (value === null || value === undefined){
        return "";
    }

    let _inputFormat = "";
    let _cultureInfo = "es-ES";
    let _decimals = 0;
    let _style = "decimal";
    let _currency = "UYU";
    if (inputFormat && typeof inputFormat === "object"){
        _inputFormat = inputFormat.format ?? _inputFormat;
        _cultureInfo = inputFormat._cultureInfo ?? _cultureInfo;
        if (_inputFormat.startsWith('N')) {
            _decimals = parseInt(_inputFormat.slice(1), 10);                                                                
        } else if (_inputFormat.startsWith('C')) {
            _decimals = parseInt(_inputFormat.slice(1), 10);
            _style = "currency";
            _currency = inputFormat.currency ?? _currency;
        }
    }else{
        _inputFormat = inputFormat;
    }

    if (_inputFormat === "cedula"){
        let cedula = value.toString().trim();
        if (cedula.length === 8){
            return cedula.replace(/\D/g, '').replace(/^(\d{1})(\d{3})(\d{3})(\d{1})$/, '$1.$2.$3-$4');
        }else{
            return cedula.replace(/\D/g, '').replace(/^(\d{3})(\d{3})(\d{1})$/, '$1.$2-$3');
        }
    }

    switch(type){
        case "boolean":
            return (value === true || value === "true" || value ===1) ? "SI" : "NO";
            break;
        case "number": 
        case "integer": 
        case "int": 
            if (isNaN(value)){
                return value;
            }else{
                let _inputFormat = {
                    "style": _style,
                    "currency": _currency,
                    "minimumFractionDigits": _decimals,
                    "maximumFractionDigits": _decimals,
                    "useGrouping": true
                };
                // Formato de número con separadores de miles y decimales            
                _cultureInfo = _cultureInfo.replace("_", "-");
                const formatoNumerico = new Intl.NumberFormat(_cultureInfo, _inputFormat);
                return formatoNumerico.format(value*1);
            }
            break;
        case "datetime": 
        case "date-time": 
        case "dateTime": 
        case "date": 
            if (value !== undefined && value !== null){
                if (_inputFormat){
                    //Hago el cambio porque es distinto el formato en moment
                    _inputFormat = _inputFormat.replace("dd/MM/yyyy","DD/MM/yyyy");
                    return moment(value).format(_inputFormat);
                }else{
                    return moment(value).toISOString();
                }
            }else{
                return "";
            }
            break;
        case "string":
            return value;
            break;
        default:
            return value;
    }
}

export async function parseSchema(){

    //Si ya es un jsonSchemae React... no hago nada.
    if (!arguments.length || arguments.length < 1){
        console.error("NO PUEDO PARSEAR con arguments: " + arguments);
    }
    if (!arguments[1]){
        return arguments[1];
    }

    if (arguments[1].$$typeof !== undefined){
        return arguments[1];
    }

    let _component = arguments[0];
    // let _schema = clone(arguments[1]);
    let _schema = arguments[1];
    let _input = arguments[2] ?? null;
    let _result = null;
    let _value = null;
    if (Array.isArray(_schema)){
        _schema.map(async (_child) => {
            _child = await parseSchema(_component, _child, _input);
        });
        _result = _schema;
    }

    if (typeof _schema === "object" && _schema.type){
        switch (_schema.type){
            // case 'executeAction': 
            //     if (!_component.props.jsonSchema.options.actions[_schema.name]){
            //         if ((!_component[_schema.name]) || (!(typeof _component[_schema.name] == "function"))){
            //             if ((!_component[_schema.name]) || (!(typeof _component[_schema.name] == "function"))){
            //                 console.log("No existe la acción " + _schema.name);
            //             }else{
            //                 let _result = _component[_schema.name].apply(null, [_component, _input]);
            //                 if (_schema.then){
            //                     _result = parseSchema.apply(null, [_component, _schema.then, _result]);
            //                 }
            //             }                    
            //         }else{
            //             let _result = _component[_schema.name].apply(null, [_component, _input]);
            //             if (_schema.then){
            //                 _result = parseSchema.apply(null, [_component, _schema.then, _result]);
            //             }
            //         }                    
            //     }else{
            //         let _result = _component.props.jsonSchema.options.actions[_schema.name].apply(null, [_component, _input]);
            //         if (_schema.then){
            //             _result = parseUISchema.apply(null, [_component, _schema.then, _result]);
            //         }
            //     }
            //     break;
            // case "httpRequest":
            //     httpRequest(_component, _schema.props, null);
            //     break;
            // case "setData":
            //     _value = translateRelativePaths(_schema.props.value, _component, _input);
            //     _component.setData(_component, _schema.props.name, _value, _schema.props.setState);
            //     break;
            // case "setDataSource":
            //     _value = translateRelativePaths(_schema.props.value, _component, _input);
            //     let _totalRows = translateRelativePaths(_schema.props.totalRows, _component, _input);
            //     let _setState = translateRelativePaths(_schema.props.setState, _component, _input);
            //     _component.setDataSource(_value, _totalRows, _setState);
            //     break;
            // case "map":
            // let _output = clone(_schema.output);
            // map(_component, _input, _output);
            // if (_schema.then){
            //     parseSchema(_component, _schema.then, _output);
            // }
            // _result = _output;
            //     break;
            case "clone": 
                let _schemaToClone = await parseSchema(_component, _schema.props, _input);
                _result = clone(_schemaToClone);
                break;
            case "concat":
                _result = concat(_component, _schema.props, _input);
                if (_schema.then){
                    await parseSchema(_component, _schema.then, _result);
                }
    
                break;
            case "conditional":
                let _a = await parseSchema(_component, _schema.props.a, _input);
                let _b;
                let _condResult = _a;
                if (_schema.props.b !== undefined){
                    let _operator = await parseSchema(_component, _schema.props.operator, _input);
                    if (_operator === undefined){
                        console.error("No tengo operador definido para la condición " + JSON.stringify(_schema.props));
                    }
                    _b = await parseSchema(_component, _schema.props.b, _input);
                    if (isNaN(parseFloat(_a*1)) || parseFloat(_a*1).toString() !== _a){
                        _condResult = eval('_a' + _operator + '_b');
                    }else{
                        _condResult = eval(_a + _operator + _b);
                    }
                }                
                _result = (_condResult) ? await parseSchema(_component, _schema.props.then, _input) : await parseSchema(_component, _schema.props.else, _input);
                break;
            case "mapObject":
                // if (!_schema.source){
                //     _schema.source = _component;
                // }else{
                //     if (_schema.source === "#_input"){
                //         _schema.source = _input;
                //     }else{
                //         _schema.source = parseSchema(_component, _schema.source, _input);
                //     }
                // }
                // _result = mapObject(_component, _schema.source, _schema.output, _schema.orderBy);    
                // _result = parseSchema(_component, _result, _input);
                
                if (!_schema.source){
                    console.log("no tengo source xa ejecutar mapObject con ouput: " + _schema.output);
                    _result = null;
                }else{
                    if (_schema.source === "#_input"){
                        _schema.source = _input;
                    }else{
                        _schema.source = await parseSchema(_component, _schema.source, _input);
                    }
                    _result = await mapObject(_component, _schema.source, _schema.output, _schema.orderBy);    
                    _result = await parseSchema(_component, _result, _input);
                }
                
                break;
            case "uiComponent":
                //Si es un jsonSchema entonces no modifico las props.
//                if (!(coreTokenExists(_schema, "props.jsonSchema" )&& coreTokenExists(_schema, "props.uiSchema" ))){
                    // let _clonedSchema = _schema;
                    let _clonedSchema = clone(_schema);
                    //Por las dudas que el nombre sea dinámico...
                    _clonedSchema.name = await parseSchema(_component, _clonedSchema.name, _input);

                    // if (_clonedSchema.name === "Typography"){
                    //     console.log("typography: " +  _input);
                    // }
                    // if (_schema.cloneMe){
                        // _clonedSchema = clone(_schema);
                    // }else{
                    //     _clonedSchema = _schema;
                    // }
                    //Primero los hijos...
                    if (_clonedSchema.children){
                        _clonedSchema.children = await parseSchema(_component, _clonedSchema.children, _input);
                    }
                    if (_clonedSchema.props){
                        _clonedSchema.props = await parseSchema(_component, _clonedSchema.props, _input);
                    }
                    if (_clonedSchema.content){
                        _clonedSchema.content = await parseSchema(_component, _clonedSchema.content, _input);
                    }

                    //Por las dudas que el nombre sea dinámico...
                    _clonedSchema.name = await parseSchema(_component, _clonedSchema.name, _input);

                    _result = await getMUIComponent(_clonedSchema);
                // }else{
                //     coreSetToken(_schema,"props.jsonSchema.options.actions.notifyToParent", _component.childNotification);
                //     _result = getMUIComponent(_schema);
                // }
                break;
            case "html":
                    let _clonedHtmlSchema = clone(_schema);
                    //Primero los hijos...
                    if (_clonedHtmlSchema.children){
                        _clonedHtmlSchema.children = await parseSchema(_component, _clonedHtmlSchema.children, _input);
                    }
                    if (_clonedHtmlSchema.props){
                        _clonedHtmlSchema.props = await parseSchema(_component, _clonedHtmlSchema.props, _input);
                    }
                    if (_clonedHtmlSchema.content){
                        _clonedHtmlSchema.children = await parseSchema(_component, _clonedHtmlSchema.content, _input);
                    }

                    //Por las dudas que el nombre sea dinámico...
                    _clonedHtmlSchema.name = await parseSchema(_component, _clonedHtmlSchema.name, _input);
                    _result = createElement(_clonedHtmlSchema.name, _clonedHtmlSchema.props, _clonedHtmlSchema.children);
                    //_result = "<" + _clonedHtmlSchema.name +" " + ">" + _clonedHtmlSchema.content + _clonedHtmlSchema.children + "</" + _clonedHtmlSchema.name +">";
                break;
            case "component":
                //Por las dudas que el nombre sea dinámico...
                let _componentName = await parseSchema(_component, _schema.name, _input);

                if (coreTokenExists(_component, "coreDefinition.components." + _componentName)){
                    if (!_component.state.initializingComponent[_componentName]){

                        if (_component.coreDefinition.components[_componentName].$$typeof){
                            _result = _component.coreDefinition.components[_componentName];
                        }else{
                            let _componentSchema = clone(_component.coreDefinition.components[_componentName]);
                            if (typeof _componentSchema.name === "object" || _componentSchema.name.startsWith("#/")){
                                _componentSchema.name = await parseSchema(_component, _componentSchema.name, _input);
                            }
                            _componentSchema.props = await parseSchema(_component, _componentSchema.props, _input);
    
                            let Component;
                            coreSetToken(_componentSchema, "props.jsonSchema.options.actions.notifyToParent", _component.childNotification);
                            _componentSchema.props.key = _componentSchema.props.key ?? _componentName ;
                            _componentSchema.raw = true;
                            Component = await getMUIComponent(_componentSchema);
                            _result =  <Component {..._componentSchema.props}></Component>;

                        }

                    }else{
                        _result = null;
                    }
                }
                break;
            case "uiSchema": 
                //Por las dudas que el nombre sea dinámico...
                let _uiSchemaName = await parseSchema(_component, _schema.name, _input);

                if (coreTokenExists(_component, "coreDefinition.uiSchema." + _uiSchemaName)){
                    if (!_component.state.initializingUiSchema[_uiSchemaName]){
                            let _componentSchema = clone(_component.coreDefinition.uiSchema[_uiSchemaName]);
                            if (_schema.props){
                                let _propsToAdd = clone(_schema.props);
                                _propsToAdd = await parseSchema(_component, _propsToAdd, _input);
                                _componentSchema.props = coreJsonMerge(_componentSchema.props, _propsToAdd);
                            }

                            _result = await parseSchema(_component, _componentSchema, _input);
    
                    }else{
                        _result = null;
                    }
                    
                }else{
                    _result = clone(_schema);
                }
                break;

            case "executeAction": 
                let _params = await parseSchema(_component, _schema.props, _input);
                _result = await _component.executeAction(_schema.name, _params, _input);
                break;
            case "castToType": 
                let _castFunctionParams = await parseSchema(_component, _schema.props, _input);
                _result = castToType(_castFunctionParams.type, _castFunctionParams.value, _castFunctionParams.inputFormat);
                //_result = await _component.executeAction(_schema.name, _params, _input);
                break;
            case "executeFunction": 
                let _executeFunctionParams = await parseSchema(_component, _schema.props, _input);
                _result = castToType(_executeFunctionParams.type, _executeFunctionParams.value, _executeFunctionParams.inputFormat);
                //_result = await _component.executeAction(_schema.name, _params, _input);
                break;
            case "xuiSchema":
                if (coreTokenExists(_component, "coreDefinition.uiSchema." + _schema.name)){
                    let _componentSchema = _component.coreDefinition.uiSchema[_schema.name];
                    if (_componentSchema.cloneMe){
                        _componentSchema = clone(_componentSchema);
                        delete _componentSchema.cloneMe;
                    }
                    if (_schema.props){
                        let _propsToAdd = clone(_schema.props);
                        _propsToAdd = await parseSchema(_component, _propsToAdd, _input);
                        _componentSchema.props = coreJsonMerge(_componentSchema.props, _propsToAdd);
                    }

                    _result = await parseSchema(_component, _componentSchema, _input);
                }
                break;                
            default:
                for(var prop in _schema){
                    _schema[prop] = await parseSchema(_component, _schema[prop], _input);
                }
                _result = _schema;            
        }    
    }else{
        //Puede ser un objeto común que tengo que ir parseando..
        if (typeof _schema === "object"){
            for(var prop in _schema){
                _schema[prop] = await parseSchema(_component, _schema[prop], _input);
            }
            _result = _schema;
        }else{
            //Es un string
            if (typeof _schema === "string"){
                _schema = translateRelativePaths(_schema, _component, _input);
                _schema = await translateFunction(_schema, _component);
                _result = _schema;
            }else{
                _result = _schema;
            }
        }
    }
    return _result;
}

export async function executeSchema(){

    //Si ya es un jsonSchemae React... no hago nada.
    if (!arguments.length || arguments.length < 1){
        console.error("NO PUEDO PARSEAR con arguments: " + arguments);
    }

    if (arguments[1].$$typeof !== undefined){
        return arguments[1];
    }

    let _component = arguments[0];
    let _schema = clone(arguments[1]);
    let _input = arguments[2] ?? null;
    let _result = null;
    let _value = null;
    if (Array.isArray(_schema)){
        _schema.map(async (_child) => {
            _child = await parseSchema(_component, _child, _input);
        });
        _result = _schema;
    }

    if (typeof _schema === "object" && _schema.type){
        switch (_schema.type){
            case 'executeAction': 
                if (!_component.coreDefinition.jsonSchema.options.actions[_schema.name]){
                    if ((!_component[_schema.name]) || (!(typeof _component[_schema.name] == "function"))){
                        if ((!_component[_schema.name]) || (!(typeof _component[_schema.name] == "function"))){
                            console.log("No existe la acción " + _schema.name);
                        }else{
                            let _result = _component[_schema.name].apply(null, [_component, _input]);
                            if (_schema.then){
                                _result = await executeSchema.apply(null, [_component, _schema.then, _result]);
                            }
                        }                    
                    }else{
                        let _result = _component[_schema.name].apply(null, [_component, _input]);
                        if (_schema.then){
                            _result = await executeSchema.apply(null, [_component, _schema.then, _result]);
                        }
                    }                    
                }else{
                    let _result = _component.coreDefinition.jsonSchema.options.actions[_schema.name].apply(_component, [_input]);
                    if (_schema.then){
                        _result = await executeSchema.apply(null, [_component, _schema.then, _result]);
                    }
                }
                break;
            case "httpRequest":                
                httpRequest(_component, _schema.props, null);
                break;
            case "setData":
                _value = translateRelativePaths(_schema.props.value, _component, _input);
                _component.setData(_component, _schema.props.name, _value, _schema.props.setState);
                break;
            case "setDataSource":
                _value = translateRelativePaths(_schema.props.value, _component, _input);
                let _totalRows = translateRelativePaths(_schema.props.totalRows, _component, _input);
                let _page = translateRelativePaths(_schema.props.page, _component, _input);
                let _size = translateRelativePaths(_schema.props.size, _component, _input);
                let _setState = translateRelativePaths(_schema.props.setState, _component, _input);
                _component.setDataSource(_value, _totalRows, _page, _size, _setState);
                break;
            case "map":
            let _output = clone(_schema.output);
            map(_component, _input, _output);
            if (_schema.then){
                await executeSchema(_component, _schema.then, _output);
            }
            _result = _output;
                break;
            case "concat":
                _result = concat(_component, _schema.props, _input);
                if (_schema.then){
                    await executeSchema(_component, _schema.then, _result);
                }
    
                break;
            case "mapObject":
                // if (!_schema.source){
                //     _schema.source = _component;
                // }else{
                //     if (_schema.source === "#_input"){
                //         _schema.source = _input;
                //     }else{
                //         _schema.source = executeSchema(_component, _schema.source, _input);
                //     }
                // }
                // _result = mapObject(_component, _schema.source, _schema.output, _schema.orderBy);    
                if (_schema.source){
                    if (_schema.source === "#_input"){
                        _schema.source = _input;
                    }else{
                        _schema.source = await executeSchema(_component, _schema.source, _input);
                    }
                    _result = await mapObject(_component, _schema.source, _schema.output, _schema.orderBy);    
                }else{
                    _result = null;
                }

                break;            

        }    
    }
    return _result;
}

export function prepareCoreDefinitionSchemaFromCoreMetaData(coreMetaData, propsCustomization){
    var schema = JSON.parse(coreMetaData.jsonData);
    if (coreMetaData.javascriptData !== undefined && coreMetaData.javascriptData !== ""){
      var actionFn = eval(coreMetaData.javascriptData);
      schema.coreDefinition.jsonSchema.options.actions = {...schema.coreDefinition.jsonSchema.options.actions, ...actionFn()};
    }

    if (!coreTokenExists(schema, "coreDefinition.jsonSchema")){
        console.log("acá tenemos un problema al preparar el schema");
    }else{
        if (schema.coreDefinition.jsonSchema.data === undefined){
            if (!coreTokenExists(schema, "coreDefinition.jsonSchema.schema.type")){
                throw new Error("Falta la definición de schema.type en el componente: " + coreMetaData.id);
            }

            if (schema.coreDefinition.jsonSchema.schema.type === "object"){
                schema.coreDefinition.jsonSchema.data = {};
            }else{
                schema.coreDefinition.jsonSchema.data = "";
            }
        }
    }

    if (propsCustomization !== null && propsCustomization !== undefined){
        schema.coreDefinition = coreJsonMerge(schema.coreDefinition, propsCustomization);
    }

    if (!coreTokenExists(schema, "coreDefinition.jsonSchema.options.id") && coreTokenExists(schema, "id")){
        coreSetToken(schema,"coreDefinition.jsonSchema.options.id", schema.id);
    }
    delete schema.id;
    return schema;
}